import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import Text, { Title } from '../../../packages/kiti/components/presentation/Text'
import { useModalData } from '../../../components/modals/ModalsContext'
import LineSeparator from '../../../packages/kiti/components/helpers/LineSeparator'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import { useOpenEditPlacesModal } from '../../../utils/routes/modals/modalsActions'

const ModalHeader = () => {
  const { t } = useTranslation('editPlace')
  const { id, initialState } = useModalData()
  const isEditing = id > 0
  const context = isEditing && 'edit'
  const title = t('title', { context })
  const openBulkModal = useOpenEditPlacesModal()

  return (
    <>
      <Grid justify="space-between" align="center">
        <Col flex={1}>
          <Title size="h5" bold>
            {title}
          </Title>
        </Col>
        {!isEditing && (
          <Col>
            <Text color="primary" size="xsmall" bold onClick={() => openBulkModal({ ...initialState })}>
              {t('bulkRegistration')}
            </Text>
          </Col>
        )}
      </Grid>

      <LineSeparator weight={2} />
      <Separator weight={6} />
    </>
  )
}

export default ModalHeader
